import { AuthLayout } from "@/components/src/signin/signin-components/auth-layout.component";
import { supabase } from "@/lib/supabase";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export const SetPasswordPage = () => {
	const [password, setPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [errorMessage, setErrorMessage] = useState<string | null>(null);
	const [loading, setLoading] = useState(false);
	const [showPassword, setShowPassword] = useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setErrorMessage(null);

		if (password !== confirmPassword) {
			setErrorMessage("Die Passwörter stimmen nicht überein");
			return;
		}

		if (password.length < 6) {
			setErrorMessage("Das Passwort muss mindestens 6 Zeichen lang sein");
			return;
		}

		setLoading(true);

		const { error } = await supabase.auth.updateUser({
			password: password,
			// maps to the auth.users.raw_user_meta_data
			data: {
				hasPassword: true,
			},
		});

		if (error) {
			setErrorMessage("Fehler beim Setzen des Passworts");
			setLoading(false);
		} else {
			window.location.href = "/";
		}
	};

	return (
		<AuthLayout
			title="Neues Passwort setzen"
			subtitle="Geben Sie Ihr neues Passwort ein."
		>
			<form onSubmit={handleSubmit} className="space-y-4">
				<div className="space-y-2">
					<Label htmlFor="password">Neues Passwort</Label>
					<div className="relative">
						<Input
							id="password"
							name="password"
							type={showPassword ? "text" : "password"}
							placeholder="Mindestens 6 Zeichen"
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							autoComplete="new-password"
							required
							autoFocus
							className="h-12 pr-10"
							aria-label="Neues Passwort"
						/>
						<button
							type="button"
							onClick={() => setShowPassword(!showPassword)}
							className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
							aria-label={showPassword ? "Passwort verbergen" : "Passwort anzeigen"}
						>
							{showPassword ? (
								<EyeOff className="h-5 w-5" />
							) : (
								<Eye className="h-5 w-5" />
							)}
						</button>
					</div>
				</div>

				<div className="space-y-2">
					<Label htmlFor="confirmPassword">Passwort bestätigen</Label>
					<div className="relative">
						<Input
							id="confirmPassword"
							name="confirmPassword"
							type={showConfirmPassword ? "text" : "password"}
							placeholder="Passwort wiederholen"
							value={confirmPassword}
							onChange={(e) => setConfirmPassword(e.target.value)}
							autoComplete="new-password"
							required
							className="h-12 pr-10"
							aria-label="Passwort bestätigen"
						/>
						<button
							type="button"
							onClick={() => setShowConfirmPassword(!showConfirmPassword)}
							className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
							aria-label={showConfirmPassword ? "Passwort verbergen" : "Passwort anzeigen"}
						>
							{showConfirmPassword ? (
								<EyeOff className="h-5 w-5" />
							) : (
								<Eye className="h-5 w-5" />
							)}
						</button>
					</div>
				</div>

				{errorMessage && (
					<div className="rounded-md bg-red-50 border border-red-200 p-3">
						<p className="text-sm text-red-800">{errorMessage}</p>
					</div>
				)}

				<Button
					type="submit"
					disabled={loading}
					size="lg"
					className="w-full h-12 text-base"
				>
					{loading ? "Wird gespeichert..." : "Passwort speichern"}
				</Button>
			</form>
		</AuthLayout>
	);
};
